// Shared chrome for every page: navigation, theme, language, cookie consent.
import { initCookieConsent } from '../core/consent';
import { applyTranslations, initLanguageSwitch } from '../core/i18n';
import { initNav } from '../core/nav';
import { initThemeSwitch } from '../core/theme';

initNav();
initThemeSwitch();
initLanguageSwitch();
applyTranslations();
initCookieConsent();
